import { NewAccount } from './NewAccount'
import { Preferences } from './Preferences'
import { StartingPage } from './StartingPage'
import { SignIn } from './SignIn'
import { ForgotPassword } from './ForgotPassword'
import { TermsConditions } from './TermsConditions'
import { AdditionalItems } from './AdditionalItems'
import {
    CompletedJobs,
    CompletedJobsItem,
    CompletedJobItemDetailed
} from './CompletedJobs'
import { ContactUs } from './ContactUs'
import { SideMenu } from './SideMenu'
import { PublishedJob } from './PublishedJob'
import { ReviewProvider } from './ReviewProvider'
import { SetJobDetails } from './SetJobDetails'
import { Common } from './Common'
import { ViewBids } from './ViewBids'
import { BidAccepted } from './BidAccepted'
import { Chat } from './Chat'
import { WaitingForAuthorization } from './WaitingForAuthorization'
import {
    AcceptDialog,
    AddPictures,
    Comment,
    DialogBox,
    JobCategory,
    JobDetails,
    JobItemDetails,
    LocationSearch,
    NumberOfItems,
    PasswordChecker,
    PickupLocationInfo,
    PickupTime,
    SideMenuHeader,
    Timer,
    ChatProviderMessageItem,
    InfoDialog
} from './Components'
import { PickupLocation } from './PickupLocation'
import { SetAvailability } from './SetAvailability'

const Components = {
    AcceptDialog: AcceptDialog,
    Uploader: AddPictures,
    Comment: Comment,
    CompletedJobDetailed: CompletedJobItemDetailed,
    DialogBox: DialogBox,
    JobCategory: JobCategory,
    JobDetails: JobDetails,
    JobItemDetails: JobItemDetails,
    LocationSearch: LocationSearch,
    NumberOfItems: NumberOfItems,
    PasswordChecker: PasswordChecker,
    PickupLocationInfo: PickupLocationInfo,
    PickupTime: PickupTime,
    SideMenuHeader: SideMenuHeader,
    Timer: Timer,
    ChatProviderMessageItem: ChatProviderMessageItem,
    InfoDialog: InfoDialog
}

export const Strings = {
    StartingPage: StartingPage,
    PickupLocation: PickupLocation,
    SignIn: SignIn,
    ForgotPassword: ForgotPassword,
    NewAccount: NewAccount,
    Preferences: Preferences,
    Common: Common,
    TermsConditions: TermsConditions,
    AdditionalItems: AdditionalItems,
    CompletedJobs: CompletedJobs,
    CompletedJobsItem: CompletedJobsItem,
    ContactUs: ContactUs,
    SideMenu: SideMenu,
    PublishedJob: PublishedJob,
    ReviewProvider: ReviewProvider,
    JobDetails: SetJobDetails,
    ViewBids: ViewBids,
    BidAccepted: BidAccepted,
    Chat: Chat,
    Components: Components,
    SetAvailability: SetAvailability,
    WaitingForAuthorization: WaitingForAuthorization
}



// WEBPACK FOOTER //
// ./src/localization/index.ts